module.exports = "/static/assets/bd9133aa1169171ed2c1fc1bb37dc0ca.png";